<template>
  <ul>
    <li>
      <router-link :to="'/'" class="hover-opacity-100 opacity-75">
        <i class="text-white flaticon2-shelter icon-1x"></i>
      </router-link>
    </li>
    <li v-for="(crumb, idx) in crumbs" :key="idx">
      <span class="text-white">></span>
      <router-link
        :class="isLast(idx) ? 'disabled' : ''"
        class="hover-opacity-100 opacity-75"
        :to="!isLast(idx) ? `${crumb.route}` : ''"
        @click="selected(crumb)"
      >
        {{ crumb.title }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    crumbs: {
      type: Array,
      required: true,
    },
  },
  methods: {
    isLast(index) {
      return index === this.crumbs.length - 1;
    },
    selected(crumb) {
      this.$emit("selected", crumb);
    },
  },
};
</script>

<style scoped lang="scss">
ul {
  list-style-type: none;
  display: flex;
  gap: 1rem;
  li {
    display: flex;
    gap: 1rem;

    a {
      color: white;
    }
  }
}

.disabled {
  pointer-events: none;
}
</style>
